import { getAppPerfTrackingEnabled } from '../../../performance-profiling';

// This function is used to get the feature flags that should be passed down to Forge Custom UI apps
export const getPlatformFeatureFlags = (): string[] => {
	const platformFeatureFlags: string[] = [];
	// Add feature flags that are required to be passed down to the iframe
	// EXAMPLE:
	// if (fg(<flag-name>)) {
	// 	platformFeatureFlags.push(<flag-name>);
	// }

	if (getAppPerfTrackingEnabled()) {
		platformFeatureFlags.push('forge-ui-iframe-analytics');
	}

	return platformFeatureFlags;
};
